<template>
    <div class="content">
        <div class="tableTit">
            <p class="tabtitBg"></p>
            <h6>知识库资料</h6>
            <div class="head">
                <el-input class="querys" placeholder="请输入文件名关键字" v-model="fileName" clearable></el-input>
                <el-select v-model="userName" placeholder="请选择" style="margin-right: 5px;" clearable>
                    <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId">
                    </el-option>
                </el-select>
                <el-button class="titBtn" style="margin-top:0px;margin-left:5px" type="success" @click="search"
                    icon="el-icon-search">搜索</el-button>
                <el-button class="titBtn" style="margin-top:0px" type="primary" icon="el-icon-plus"
                    @click="uploadFileClick()">上传文件</el-button>
            </div>
        </div>
        <div class="tabBody">
            <el-table ref="multipleTable" :header-cell-style="{ background: 'rgba(49,130,222,0.1)' }" :data="tabledata"
                :height="tableHeight" border>
                <el-table-column prop="fileName" align='center' label="文件名"></el-table-column>
                <el-table-column prop="fileType" align='center' label="文件类型"></el-table-column>
                <el-table-column prop="userName" align='center' label="上传者"></el-table-column>
                <el-table-column prop="operTime" width="180" align='center' label="上传日期"></el-table-column>
                <el-table-column width="200" align='center' label="操作">
                    <template slot-scope="scope">
                        <!--<el-tooltip class="item" effect="dark" content="下载" placement="top-start">
							<el-button type="primary" icon="el-icon-download" class="tableedit" round></el-button>
						</el-tooltip>-->
                        <!--<el-tooltip class="item" effect="dark" content="预览" placement="top-start">
							<el-button type="success" icon="el-icon-view" class="tableedit" round></el-button>
						</el-tooltip>-->
                        <!-- <el-button type="primary" icon="el-icon-download" class="tableedit" round
              @click='downloadrow(scope.$index,scope.row)'></el-button> -->
                        <el-button type="primary" icon="el-icon-download" class="tableedit" round
                            @click='downloadFile(scope.row)' title="下载"></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle
                            @click.native="deleteFile(scope.$index, scope.row)" title="删除"></el-button>
                        <el-button type="primary" icon="el-icon-view" circle @click="See(scope.$index, scope.row)"
                            title="预览"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="fye">
            <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums">
            </pagintion>
        </div>
        <knowledgebasepopup v-if="knowledgebasepopupDialog == true" @knowledgeDialogCancel="knowledgeDialogCancel">
        </knowledgebasepopup>

        <el-dialog id="d1" title="预览" :visible.sync="PreviewDialogVisible" append-to-body width="70%"
            :style="{ 'position': 'fixed' }" center :before-close="closePdf">
            <div>
                <iframe ref="pdfIframe" :src="pdfSrc" width="100%" height="600px" id="iframe"></iframe>
            </div>
        </el-dialog>

        <el-dialog id="d2" title="预览" :visible.sync="PreviewDocxDialogVisible" append-to-body width="70%"
            :style="{ 'position': 'fixed','overflow': 'hidden' }" center :before-close="closeDoc">
            <div class="preview-box" ref="bodyContainer" v-loading="loading" style="height: 659px; overflow-y: auto;"></div>
        </el-dialog>

        <el-dialog id="d3" title="预览" :visible.sync="PreviewXlsxDialogVisible" append-to-body width="70%"
            :style="{ 'position': 'fixed','overflow': 'hidden' }" center :before-close="closeXlsx">
            <div v-html="excelHtml" ref="execl" v-loading="excelLoading" style="height: 659px; overflow-y: auto;"></div>
        </el-dialog>

        <el-dialog id="d4" title="预览" :visible.sync="PreviewPicDialogVisible" append-to-body width="70%"
            :style="{ 'position': 'fixed','overflow': 'hidden' }" center :before-close="closePic">
            <img :src="imgSrc"/>
        </el-dialog>
    </div>
</template>

<script>
import pagintion from '@/components/mangement/pagintion.vue';
import knowledgebasepopup from '../popup/knowledgebasepopup.vue';
import {
    knowledgebasequery
} from '@/api/api.js'
import { knowledgebasequeryname, deleteFile, knowledgebaseDownloadFile } from '../../../api/api';
import axios from "axios";
let docx = require("docx-preview");
import { renderAsync } from "docx-preview";
window.JSZip = require('jszip')
import * as XLSX from 'xlsx'

export default {
    data() {
        return {
            loading: false,
            excelLoading:false,
            PreviewDialogVisible: false,
            PreviewDocxDialogVisible: false,
            PreviewXlsxDialogVisible:false,
            PreviewPicDialogVisible:false,
            imgSrc:'',
            excelHtml: '',
            pdfSrc: "",
            total: null,
            pageSize: 20, //每页多少条数据分页
            pageNum: 1, //当前页
            pageNums: null,
            tableHeight: window.innerHeight - 180,
            knowledgebasepopupDialog: false,
            tabledata: [],
            userList: [],
            userName: '',
            fileName: '',
            docxOptions: {
                className: "kaimo-docx-666", // string：默认和文档样式类的类名/前缀
                inWrapper: true, // boolean：启用围绕文档内容的包装器渲染
                ignoreWidth: false, // boolean：禁用页面的渲染宽度
                ignoreHeight: false, // boolean：禁止渲染页面高度
                ignoreFonts: false, // boolean：禁用字体渲染
                breakPages: true, // boolean：在分页符上启用分页
                ignoreLastRenderedPageBreak: true, // boolean：在 lastRenderedPageBreak 元素上禁用分页
                experimental: false, // boolean：启用实验功能（制表符停止计算）
                trimXmlDeclaration: true, // boolean：如果为true，解析前会从​​ xmlTemplate 文档中移除 xmlTemplate 声明
                useBase64URL: false, // boolean：如果为true，图片、字体等会转为base 64 URL，否则使用URL.createObjectURL
                useMathMLPolyfill: false, // boolean：包括用于 chrome、edge 等的 MathML polyfill。
                showChanges: false, // boolean：启用文档更改的实验性渲染（插入/删除）
                debug: false, // boolean：启用额外的日志记录
            },
        }
    },
    components: {
        pagintion,
        knowledgebasepopup
    },
    mounted() {
        let params = {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            fileName: this.fileName,
            userId: this.userName,
        };
        this.getList(params);
        this.getuserList();
    },
    methods: {
        search() {
            let params = {
                pageSize: 20,
                pageNum: 1,
                fileName: this.fileName,
                userId: this.userName,
            };
            this.getList(params);
        },
        DsyData(data) { //多少页
            this.pageNum = data.dsy;
            let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                fileName: this.fileName,
                userId: this.userName,
            }
            let requestParams = { ...params, ...this.condition };
            this.getList(requestParams)
        },
        DstData(data) { //多少条
            this.pageSize = data.dst;
            let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                fileName: this.fileName,
                userId: this.userName,
            }
            let requestParams = { ...params, ...this.condition };
            this.getList(requestParams)
        },
        getuserList() {
            knowledgebasequeryname().then((res) => {
                this.userList = res.data
            })
        },
        getList(params) {
            knowledgebasequery(params).then((res) => {
                this.tabledata = res.data;
                this.total = res.total;
            });
        },
        uploadFileClick() {
            this.knowledgebasepopupDialog = true,
                console.log("弹窗执行了");
        },
        knowledgeDialogCancel(){
            this.knowledgebasepopupDialog=false;
        },
        //删除文件
        deleteFile(index, item) {
            // 显示确认删除的弹窗
            this.$confirm('确认删除此文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 构建请求URL，包含Access-Token
                const url = `/userApi/minio/removeObject/${item.fileSourceName}`;
                // 构建请求头，包含Content-Type和Access-Token
                const headers = {
                    "Content-Type": "application/json",
                    "Access-Token": this.$store.state.token
                };
                // 使用axios的get方法发送请求
                axios.get(url, { headers }).then(res => {
                    if (res.data.code === 200) {
                        // 删除操作成功的逻辑
                        console.log('File deleted successfully');
                        this.tabledata.splice(index, 1);
                    } else {
                        // 删除操作失败的逻辑
                        console.error('Error deleting file:', res.data.message);
                        this.$notify({
                            title: 'Error',
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    // 处理请求错误
                    console.error('Error deleting file:', err);
                    this.$notify({
                        title: 'Error',
                        message: 'Failed to delete file',
                        type: 'error'
                    });
                });

                // 构建请求URL，包含Access-Token
                const url2 = `/userApi/ydb/knowledgebase/delete`;
                // 使用axios的get方法发送请求
                axios.get(url2, { headers, params: { id: item.id } }).then(res => {
                    if (res.data.code === 200) {
                        // 删除操作成功的逻辑
                        let params = {
                            pageSize: 20,
                            pageNum: 1,
                            fileName: '',
                            userId: '',
                        }
                        this.getList(params);
                        console.log('File deleted successfully');
                    } else {
                        // 删除操作失败的逻辑
                        console.error('Error deleting file:', res.data.message);
                        this.$notify({
                            title: 'Error',
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    // 处理请求错误
                    console.error('Error deleting file:', err);
                    this.$notify({
                        title: 'Error',
                        message: 'Failed to delete file',
                        type: 'error'
                    });
                });
            }).catch(() => {
                // 用户取消删除操作
                console.log('删除操作已取消');
            });
        },
        See(index, row) {
            console.log(row);
            var fileSourceName = row.fileSourceName;
            const lastIndex = fileSourceName.lastIndexOf('.');
            var fileType = fileSourceName.substring(lastIndex + 1);
            var otherPreviewUrl = '/userApi/minio/viewOtherFile/' + fileSourceName;
            if (fileType.indexOf("pdf") != -1) {//pdf预览
                const url = `/userApi/minio/viewFile/` + fileSourceName;
                const headers = {
                    "Access-Token": this.$store.state.token
                };
                fetch(url, {
                    method: 'GET',
                    headers: headers,
                }).then(response => response.blob()).then(blob2 => {
                    if (blob2 instanceof Blob) {
                        const blob = new Blob([blob2], { type: "application/pdf" });
                        this.pdfSrc = window.URL.createObjectURL(blob);
                        this.PreviewDialogVisible = true;
                    } else {
                        console.error('Response is not a file stream');
                    }
                }).catch(error => console.error('预览失败：', error));
            }
            else if (fileType.indexOf("doc") != -1 || fileType.indexOf("docx") != -1) {
                this.PreviewDocxDialogVisible = true;
                this.loading = true
                axios({
                    method: 'GET',
                    responseType: 'blob',
                    url: otherPreviewUrl,
                    headers: { 'Content-Type': 'application/octet-stream',"Access-Token": this.$store.state.token }
                }).then(response => {
                    this.loading = false;
                    this.PreviewDocxDialogVisible = true;
                    let bodyContainer = this.$refs.bodyContainer
                    // 配置
                    renderAsync(
                        response.data,
                        bodyContainer,
                        null,
                        this.docxOptions
                    )
                }).catch( res => {console.log(res);})
            }else if(fileType.indexOf("xlsx") != -1 || fileType.indexOf("xls") != -1){
                this.PreviewXlsxDialogVisible = true;
                this.excelLoading=true;
                axios({
                    method: 'GET',
                    responseType: 'arraybuffer',
                    url: otherPreviewUrl,
                    headers: {"Access-Token": this.$store.state.token }
                }).then(res => {
                    let workbook = XLSX.read(new Uint8Array(res.data), { type: "array" });
                    let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    this.excelHtml = XLSX.utils.sheet_to_html(worksheet);
                    this.excelLoading=false;
                }).catch( res => {console.log(res);})
            }else if(fileType.indexOf("jpg") != -1 || fileType.indexOf("png") != -1){
                var fileType = row.fileType;
                this.PreviewPicDialogVisible=true;
                axios({
                    method: 'GET',
                    responseType: 'arraybuffer',
                    url: otherPreviewUrl,
                    headers: {"Access-Token": this.$store.state.token}
                }).then(res => {
                    this.imgSrc = `data:${fileType};base64,` + this.arrayBufferToBase64(res.data);
                }).catch( res => {console.log(res);})
            }else{
                this.$notify({
                    title: "提示",
                    message: "该文件格式不支持预览！",
                    type: "warning",
                });
            }
        },
        arrayBufferToBase64(buffer) {
            let binary = '';
            let bytes = new Uint8Array(buffer);
            let len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        },
        closePic(){
            this.PreviewPicDialogVisible=false;
        },
        closeXlsx(){
            this.PreviewXlsxDialogVisible = false;
        },
        closePdf() {
            this.pdfSrc = '';
            this.PreviewDialogVisible = false;
        },
        closeDoc() {
            let bodyContainer = this.$refs.bodyContainer;
            renderAsync(
                null,
                bodyContainer,
                null,
                this.docxOptions
            );
            this.PreviewDocxDialogVisible = false;
        },
        //下载文件
        downloadFile(row) {
            // 构建请求URL，包含Access-Token
            const url = `/userApi/minio/downloadFile/${row.fileSourceName}`;
            // 构建请求头，包含Content-Type和Access-Token
            const headers = {
                "Access-Token": this.$store.state.token
            };
            fetch(url, {
                method: 'GET',
                headers: headers,
            }).then(response => response.blob())
                .then(blob => {
                    // 创建一个虚拟的链接元素，模拟点击下载
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = row.fileName; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
                    document.body.appendChild(link);

                    // 模拟点击
                    link.click();

                    // 移除虚拟链接元素
                    document.body.removeChild(link);
                })
                .catch(error => console.error('下载失败：', error));

        }

    }
}
</script>

<style scoped>
.querys {
    height: 30px;
    width: 200px;
    margin-right: 10px;
}

>>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;
    padding-left: 10px;
    font-size: 14px;
}

.head {
    display: flex;
    float: right;
    height: 30px;
    align-items: center;
}

>>>.el-input__icon {
    margin-top: 5px;
}
</style>
